import * as React from "react";
import WheelPickerDialog from "Components/WheelPickerDialog";
import moment from "jalali-moment";
import { useTranslation } from "react-i18next";
import BottomSheet from "Components/BottomSheet";
import { format } from "react-string-format";
import Icon from "Components/Icon";

const BottomSheetDatePicker = (props: any) => {
  const [t] = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [selectedDay, setSelectedDay] = React.useState<number>(1);
  const [selectedMonth, setSelectedMonth] = React.useState<number>(1);
  const [selectedYear, setSelectedYear] = React.useState<number>(1404);
  const inputRefs = [
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
  ];

  var days = Array.from({ length: selectedMonth < 7 ? 31 : 30 }, (v, i) => {
    return { value: i + 1, label: (i + 1).toString().padStart(2, "0") };
  });
  var monthes = Array.from({ length: 12 }, (v, i) => {
    return { value: i + 1, label: (i + 1).toString().padStart(2, "0") };
  });
  var years = Array.from(
    { length: moment().locale("fa").jYear() - 1300 + 1 },
    (v, i) => {
      return { value: 1404 - i, label: String(1404 - i).padStart(4, "0") };
    }
  );

  React.useEffect(() => {
    const jalaliDate = moment(
      props.value && props.value != "Invalid Date" ? props.value : new Date(),
      "YYYY-MM-DD"
    )
      .locale("fa")
      .format("jYYYY/jMM/jDD");
    const [year, month, day] = jalaliDate.split("/");
    setSelectedYear(Number(year));
    setSelectedMonth(Number(month));
    setSelectedDay(Number(day));
  }, [props.value]);

  const handleClickOpen = (e: any) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    const shamsiDate = `${selectedYear.toString().padStart(4, "0")}/${selectedMonth.toString().padStart(2, "0")}/${selectedDay.toString().padStart(2, "0")}`;
    const gregorianDate = moment(shamsiDate, "jYYYY/jMM/jDD")
      .locale("en")
      .format(props.format ? props.format : "YYYY-MM-DDTHH:mm:ss");
    props.onChange(gregorianDate);
    setOpen(false);
  };

  const getInputValue = (): string => {
    if (props.value && props.value != "Invalid Date") {
      const jalaliDate = moment(props.value, "YYYY-MM-DD")
        .locale("fa")
        .format("jYYYY/jMM/jDD");
      const [year, month, day] = jalaliDate.split("/");
      return `${year.toString().padStart(4, "0")}/${month.toString().padStart(2, "0")}/${day.toString().padStart(2, "0")}`;
    } else return "";
  };

  return (
    <React.Fragment>
      <div
        className={`group form-floating w-full relative ${props.errors ? ` validation-error` : ``}`}
      >
        <input
          inputMode="numeric"
          dir={props.dir ? props.dir : "ltr"}
          className="form-text transition-all pl-9 peer"
          style={{ paddingLeft: "40px" }}
          value={getInputValue()}
          onFocus={handleClickOpen}
          disabled={props.disabled}
          autoComplete="off"
          placeholder=""
        />
        <label
          htmlFor="outline"
          className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
        >
          <span className="relative">
            {props.label}
            {props.rules?.required && (
              <span style={{ color: "#d84b4b" }}>*</span>
            )}
          </span>
        </label>
        <Icon name="calendar-2" className="w-6 h-6 absolute left-3 top-3.5" />

        {props.errors && (props.errors.type as any) === "validate" && (
          <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
            {format(t("VALIDATION_ERROR_REQUIRED"), props.label)}
          </div>
        )}
      </div>

      <BottomSheet
        title={props.label}
        visible={open}
        onCancel={() => setOpen(false)}
      >
        <div
          style={{
            width: 50,
            height: 6,
            backgroundColor: "#ccc",
            borderRadius: 3,
            position: "absolute",
            top: 8,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        />
        <div className="overflow-auto px-6 pb-6">
          <div className="text-black text-sm mb-4">{`${props.label} را مشخص کنید.`}</div>

          <div className="flex space-x-4" style={{ gap: "7px" }}>
            <div className="group form-floating w-full relative">
              <input
                inputMode="numeric"
                ref={inputRefs[0]}
                className="form-text transition-all pl-9 peer"
                style={{ textAlign: "center" }}
                type="number"
                min={1}
                max={selectedMonth < 7 ? 31 : 30}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => {
                  let day = Number(e.target.value);
                  let maxValue = selectedMonth < 7 ? 31 : 30;
                  if (day < 1) setSelectedDay(1);
                  else if (day > maxValue) setSelectedDay(maxValue);
                }}
                onChange={(e) => {
                  setSelectedDay(Number(e.target.value));
                  if (e.target.value.length >= 2) inputRefs[1].current?.focus();
                }}
                value={`${selectedDay < 10 ? "0" : ""}${selectedDay}`}
              />
              <label
                htmlFor="outline"
                className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
              >
                <span className="relative">{t("DAY")}</span>
              </label>
            </div>
            <div className="group form-floating w-full relative">
              <input
                inputMode="numeric"
                ref={inputRefs[1]}
                className="form-text transition-all pl-9 peer"
                style={{ textAlign: "center" }}
                type="number"
                min={1}
                max={12}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => {
                  let month = Number(e.target.value);
                  if (month < 1) setSelectedMonth(1);
                  else if (month > 12) setSelectedMonth(12);
                }}
                onChange={(e) => {
                  setSelectedMonth(Number(e.target.value));
                  if (e.target.value.length >= 2) inputRefs[2].current?.focus();
                }}
                value={`${selectedMonth < 10 ? "0" : ""}${selectedMonth}`}
              />
              <label
                htmlFor="outline"
                className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
              >
                <span className="relative">{t("MONTH")}</span>
              </label>
            </div>
            <div className="group form-floating w-full relative">
              <input
                inputMode="numeric"
                ref={inputRefs[2]}
                className="form-text transition-all pl-9 peer"
                style={{ textAlign: "center" }}
                type="number"
                min={1300}
                max={moment().locale("fa").jYear()}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => {
                  let year = Number(e.target.value);
                  if (year < 1300) setSelectedYear(1300);
                  else if (year > moment().locale("fa").jYear())
                    setSelectedYear(moment().locale("fa").jYear());
                }}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                value={selectedYear.toString().padStart(4, "0")}
              />
              <label
                htmlFor="outline"
                className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
              >
                <span className="relative">{t("YEAR")}</span>
              </label>
            </div>
          </div>

          <div className="flex">
            <div className="flex-1">
              <WheelPickerDialog
                value={selectedDay}
                options={days}
                onChange={(value) => setSelectedDay(value)}
              />
            </div>
            <div className="flex-1">
              <WheelPickerDialog
                value={selectedMonth}
                options={monthes}
                onChange={(value) => setSelectedMonth(value)}
              />
            </div>
            <div className="flex-1">
              <WheelPickerDialog
                value={selectedYear}
                options={years}
                onChange={(value) => setSelectedYear(value)}
              />
            </div>
          </div>

          <div className="cta">
            <div className="flex justify-between items-center">
              <button
                type="button"
                className="btn btn-primary btn-lg flex items-center justify-center w-full"
                onClick={handleClose}
              >
                {t("SELECT")}
              </button>
            </div>
          </div>
        </div>
      </BottomSheet>
    </React.Fragment>
  );
};

export default BottomSheetDatePicker;
